export default function handleErrors(e) {
  const errors = [];
  if (window.newrelic != undefined) {
    window.newrelic.noticeError(e);
  }
  if (e.errors && Array.isArray(e.errors)) {
    e.errors.forEach(e => errors.push(e));
  } else {
    errors.push(e);
  }
  return errors;
}
